import React from 'react';
import { Chip, Stack } from '@mui/material';

import { secondaryBlockerLabel } from '../../../utils/secondaryBillingPresentation';

export interface SecondaryBlockerChipsProps {
  /** The row's `secondary_blockers`, in the server's order. */
  blockers: readonly string[] | null | undefined;
}

/**
 * Why the secondary cannot go yet: one outlined chip per blocker, in the
 * words of `secondaryBlockerLabel` (GDN-4023). Nothing when there are none,
 * so a clean row keeps its cell for the facts that matter.
 */
export const SecondaryBlockerChips: React.FC<SecondaryBlockerChipsProps> = ({ blockers }) => {
  if (!blockers || blockers.length === 0) return null;
  return (
    <Stack direction="row" spacing={0.5} sx={{ flexWrap: 'wrap', minWidth: 0 }} useFlexGap>
      {blockers.map(code => (
        <Chip
          key={code}
          color="warning"
          label={secondaryBlockerLabel(code)}
          size="small"
          sx={{ fontWeight: 600 }}
          variant="outlined"
        />
      ))}
    </Stack>
  );
};
